import React from "react";
import { TbPhoneCall } from "react-icons/tb";
import { HiOutlineMail } from "react-icons/hi";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-10 text-defaultText">
      <h1 className="text-3xl font-bold mb-4 flex items-center gap-2">
        <span role="img" aria-label="lock">
          🔒
        </span>{" "}
        Privacy Policy
      </h1>
      <p className="text-sm text-gray-500 mb-6">Effective Date: 01/04/2025</p>

      <section className="space-y-6">
        <p>
          Welcome to <strong>Edupro Hub</strong>! We value your trust and are
          committed to protecting your privacy. This Privacy Policy outlines how
          we collect, use, and protect your information when you use our
          platform, services, or website.
        </p>

        <div>
          <h2 className="text-xl font-semibold mb-2">
            1. Information We Collect
          </h2>
          <ul className="list-disc list-inside space-y-1">
            <li>Full Name</li>
            <li>Email Address</li>
            <li>Mobile Number</li>
            <li>Coaching Institute Name</li>
            <li>
              Student Details (Name, Roll Number, Batch, Performance Data)
            </li>
            <li>
              Other relevant information you voluntarily provide during
              onboarding or test creation
            </li>
          </ul>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">
            2. How We Use Your Information
          </h2>
          <ul className="list-disc list-inside space-y-1">
            <li>Set up and manage your coaching institute account</li>
            <li>Create and assign mock exams</li>
            <li>Deliver results and performance analytics</li>
            <li>
              Communicate with you regarding demo scheduling, support, or
              platform updates
            </li>
            <li>Improve our services and user experience</li>
            <li>
              <strong>
                We do not sell or rent your personal information to any third
                parties.
              </strong>
            </li>
          </ul>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">
            3. Data Security & Integrity
          </h2>
          <ul className="list-disc list-inside space-y-1">
            <li>
              All information is stored on secure servers with industry-standard
              encryption
            </li>
            <li>Access is restricted to authorized personnel only</li>
            <li>
              Regular audits and monitoring are conducted to prevent
              unauthorized access, misuse, or data breaches
            </li>
          </ul>
          <p className="mt-2">
            Edupro Hub is committed to maintaining the confidentiality and
            integrity of your personal and institutional data at all times.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">
            4. Cookies and Tracking
          </h2>
          <p>We may use cookies and similar technologies to:</p>
          <ul className="list-disc list-inside space-y-1">
            <li>Improve your browsing experience</li>
            <li>Understand how users interact with our website</li>
            <li>Collect analytics to improve our platform’s performance</li>
          </ul>
          <p className="mt-2">
            You may adjust your browser settings to disable cookies at any time.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">5. Your Rights</h2>
          <ul className="list-disc list-inside space-y-1">
            <li>Access the personal data we hold about you</li>
            <li>Request corrections or updates</li>
            <li>Ask us to delete your data (subject to legal requirements)</li>
          </ul>
          <p className="mt-2 flex items-center gap-2">
            To make such requests, please contact us at:           
              <HiOutlineMail className="text-lg text-primary-900" />

            <Link
              to="mailto:info@eduprohub.in"
              className="text-primary-900 underline"
            >
              info@eduprohub.in
            </Link>
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">
            6. Third-Party Tools & Services
          </h2>
          <p>
            We may integrate with trusted third-party tools for analytics,
            payment processing, or communication. These services have their own
            privacy policies, which we encourage you to review. We ensure that
            any third parties we work with also follow strong data protection
            practices.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">
            7. Updates to This Policy
          </h2>
          <p>
            We may update this Privacy Policy from time to time to reflect
            changes in technology or legal requirements. When we do, we’ll
            notify you via email or a notice on our website.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">8. Contact Us</h2>
          <p>Have questions or concerns about this Privacy Policy?</p>
          <p className="flex items-center gap-2">
            <HiOutlineMail className="text-lg text-primary-900" />
            Email:{" "}
            <Link
              to="mailto:info@eduprohub.in"
              className="text-primary-900 underline"
            >
              info@eduprohub.in
            </Link>
          </p>
          <p className="flex items-center gap-2">
            <TbPhoneCall className="text-lg text-primary-900" />
            Phone:{" "}
            <Link to="tel:+919179619315" className="text-primary-900 underline">
              +91-91796 19315
            </Link>,
          </p>{" "}
          <p className="mt-2 font-medium">
            Your trust means everything to us. At Edupro Hub, we’re committed to
            protecting your data — securely, responsibly, and transparently.
          </p>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
